<script setup lang="ts">

</script>

<template>
  <div
    id="footer"
    name="footer"
    class="text-gray-600 pt-8"
  >
    <div class="flex flex-col items-center p-4 text-sm lg:text-xs">
      <div>
        <ul class="flex flex-col space-y-1 md:space-y-0 md:flex-row items-center list-reset">
          <li class="mx-2">
            <a
              class="text-grey-darker"
              href="https://playaresorts.com/"
            >Playaresorts.com</a>
          </li>
          <li class="mx-2">
            <a
              class="text-grey-darker"
              href="/contact"
            >Contact Us</a>
          </li>
          <li class="mx-2">
            <a
              class="text-grey-darker"
              href="https://www.playaresorts.com/terms-conditions"
              target="_blank"
            >{{ $t('terms-and-conditions') }}</a>
          </li>
          <li class="mx-2">
            <a
              class="text-grey-darker"
              href="https://www.playaresorts.com/privacy-policy"
              target="_blank"
            >Privacy Policy</a>
          </li>
        </ul>
      </div>
      <div class="text-center mt-8 text-xs text-gray-400" />
    </div>
  </div>
</template>
